import styled from 'styled-components';

// TODO: replace with Box components in all filters
export const AddFilterPopoverContent = styled.div`
    padding: 16px;
    min-width: 190px;
`;
